module.exports = NavBar;